import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CircleIcon from '@mui/icons-material/Circle'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import LockIcon from '@mui/icons-material/Lock'
import TheatersOutlinedIcon from '@mui/icons-material/TheatersOutlined'
import { Button, Paper } from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import moment from 'moment-timezone'
import CalendarMonthIcon from '../../../../assets/icons/CalendarMonth.svg'
import { ProjectItem } from '../../../../components/ProjectItem/ProjectItem'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import { useProfileStore } from '../../../../store/storeProfile'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { MeetingStatus } from '../../../../swagger/dto'
import VideoPlusIcon from './../../../../assets/icons/VideoPlus.svg?react'
import { MeetingItemMenu } from './MeetingItemMenu'
import { MeetsStartAtDateChip } from './MeetsStartAtDateChip'

export const Meets = () => {
    const { meeting, isLoadingFetchMeeting } = useAssistantAdministrationStore((state) => state)
    const { setOpenDialogAddBotToMeet, projectListActive, isTempUser } = useWrapperStore(
        (state) => state,
    )

    const { isFullAccess, userTariff } = useProfileStore()

    const handleOpenAddBotToMeetDialog = () => {
        setOpenDialogAddBotToMeet(true)
    }

    const ts = Intl.DateTimeFormat().resolvedOptions().timeZone
    let startAtLast = undefined

    return (
        <div style={{ padding: '16px' }}>
            <Typography variant="caption1" sx={{ color: '#181B25', display: 'block' }} mb="24px">
                Сегодня, {moment().tz(ts).locale('ru').format('D MMMM YYYY')}
            </Typography>

            <Grid
                sx={{
                    py: 2,
                    overflow: 'auto',
                    height: 'calc(100dvh - 274px)',
                    alignContent: 'flex-start',
                }}>
                {meeting?.length === 0 && (
                    <Stack
                        sx={{
                            height: `100%`,
                            alignItems: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignContent: 'center',
                            textAlign: 'center',
                            display: 'flex',
                        }}>
                        <Paper
                            sx={{
                                background: '#F9FAFB',
                                padding: '16px',
                                borderRadius: '10px',
                                mb: 2,
                            }}>
                            <CalendarMonthIcon />
                        </Paper>
                        <Typography variant="h5" sx={{ textAlign: 'center' }}>
                            Пока что ваш календарь пуст
                        </Typography>
                        <Typography
                            variant="caption2"
                            sx={{ color: '#5A5F72', maxWidth: '252px', mt: 2, mb: 2 }}>
                            Здесь будут отображаться запланированные встречи
                        </Typography>
                        <Button
                            disabled={
                                !projectListActive?.length ||
                                isTempUser ||
                                !isFullAccess ||
                                !userTariff?.tariff?.restrictions?.is_recording_available
                            }
                            sx={{ mt: 0 }}
                            variant="contained"
                            color="primary"
                            startIcon={
                                isTempUser || !isFullAccess ? <LockIcon /> : <VideoPlusIcon />
                            }
                            aria-haspopup="true"
                            onClick={(evt) => {
                                evt.stopPropagation()
                                handleOpenAddBotToMeetDialog()
                            }}>
                            Добавить бота к встрече
                        </Button>
                        {!userTariff?.tariff?.restrictions?.is_recording_available && (
                            <Typography variant="h6" sx={{ color: '#181B25', mt: 2 }}>
                                Недоступно на Текущем уровне
                            </Typography>
                        )}
                    </Stack>
                )}

                {isLoadingFetchMeeting && (
                    <Stack
                        sx={{
                            width: '100%',
                            height: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <CircularProgress sx={{ textAlign: 'center' }} />
                    </Stack>
                )}

                {meeting && meeting.length > 0 && (
                    <>
                        {map(meeting, (item, index) => {
                            const { source, start_at, status, id, record_id, title, workplace_id } =
                                item

                            startAtLast = index ? meeting[index - 1]?.start_at : undefined

                            return (
                                <>
                                    <Grid size={12} sx={{ my: 2 }}>
                                        <MeetsStartAtDateChip
                                            startAt={start_at}
                                            startAtLast={startAtLast}
                                        />
                                    </Grid>
                                    <Grid
                                        size={12}
                                        container
                                        spacing={2}
                                        sx={{
                                            cursor: record_id ? 'pointer' : '',
                                            marginBottom: '12px',
                                            paddingBottom: '0',
                                            borderRadius: '8px',
                                            position: 'relative',
                                            '&:hover #cellBoxLengthTypo': {
                                                visibility: 'visible',
                                            },
                                            '& #cellBoxLengthTypo': { visibility: 'hidden' },
                                        }}>
                                        <Box
                                            sx={{
                                                background: '#F9FAFB',
                                                borderRadius: '12px',
                                                width: '56px',
                                                height: '56px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>
                                            <TheatersOutlinedIcon />
                                        </Box>
                                        <Grid size="grow">
                                            <Stack
                                                direction="row"
                                                spacing={0.5}
                                                sx={{
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    ml: '20px',
                                                }}>
                                                <Typography
                                                    variant="caption1"
                                                    component="p"
                                                    sx={{
                                                        color: '#181B25',
                                                        pr: 1,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        maxWidth: '300px',
                                                    }}>
                                                    {title ?? 'Название встречи'}
                                                </Typography>
                                                {status === MeetingStatus['PROCESSING'] && (
                                                    <>
                                                        <CircleIcon
                                                            sx={{
                                                                color: '#EF4848',
                                                                fontSize: '10px',
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="caption1"
                                                            component="p"
                                                            sx={{ color: '#EF4848' }}>
                                                            Идет запись
                                                        </Typography>
                                                    </>
                                                )}
                                                {status === MeetingStatus['ERROR'] && (
                                                    <>
                                                        <ErrorOutlineOutlinedIcon
                                                            sx={{
                                                                color: '#EF4848',
                                                                fontSize: '16px',
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="caption1"
                                                            component="p"
                                                            sx={{ color: '#EF4848' }}>
                                                            Возникла ошибка
                                                        </Typography>
                                                    </>
                                                )}
                                            </Stack>
                                            <Stack
                                                direction="row"
                                                spacing={0.5}
                                                sx={{
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    ml: '20px',
                                                    mt: '10px',
                                                }}>
                                                <AccessTimeIcon
                                                    sx={{ fontSize: '18px', color: '#8F93A3' }}
                                                />
                                                <Typography
                                                    variant="caption2"
                                                    component="p"
                                                    sx={{ color: '#8F93A3', paddingRight: '12px' }}>
                                                    {moment(start_at).tz(ts).format('HH:mm')}
                                                </Typography>
                                                <ProjectItem projectId={workplace_id} />
                                            </Stack>
                                            {record_id && (
                                                <Stack
                                                    direction="row"
                                                    spacing={0.5}
                                                    sx={{
                                                        ml: '20px',
                                                        mt: '10px',
                                                    }}>
                                                    <Link
                                                        sx={{ textAlign: 'center', mt: 4 }}
                                                        href={`/record/${record_id}`}>
                                                        Перейти к записи
                                                    </Link>
                                                </Stack>
                                            )}
                                        </Grid>

                                        <MeetingItemMenu
                                            idMeeting={id}
                                            status={status}
                                            source={source}
                                        />
                                    </Grid>
                                    <Divider sx={{ borderColor: '#F4F4F6' }} />
                                </>
                            )
                        })}
                    </>
                )}
            </Grid>
        </div>
    )
}
